module.exports = require("ramda/src/startsWith");